import { memo } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

export type LoaderProps = {
  className?: string
}

export const Loader = memo<LoaderProps>(({ className }) =>
  <div className={classNames(styles.root, className)}>
    <div className={styles.loader}>Loading...</div>
  </div>,
);

export default Loader;
